import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import ValueStreamDetailTable from './valueStreamDetailTable';
import BasicDetailDrillDown from 'components/basicDetailDrillDown';
import ValueStreamEdit from '../valueStreamMaintenance/valueStreamEdit';
import { getValueStreamDisplayData } from 'services/valueStreamService';
import SelectByIdModal from 'components/selectByIdModal';
import { sameByIdValue } from 'services/arrayService';
import {
    onEditValueStream,
    onValueStreamSelect,
    showValueStreamLoader,
    onValueStreamTeamUpdate,
    onFetchSelectTeamData,
    onDeleteValueStream,
} from 'actions/valueStream';
import DeleteItemCheck from 'components/deleteItemCheck';
// import { TIGHT_FIT_PARAM } from 'constants/System';

const ValueStreamDetail = () => {
    // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const allTeams = useSelector(state => state.teams.allTeam);
    const selectedOrg = useSelector(state => state.orgs.selectedOrg);
    const selectedValueStream = useSelector(state => state.valueStreams.selectedValueStream);
    const teamSelectionList = useSelector(state => state.valueStreams.teamSelectionList);
    const [selectedTeams, setSelectedTeams] = useState();
    const [displayData, setDisplayData] = useState();

    useEffect(() => {
        // update the selectedTeams
        // TODO - do not fetch if no selected valueStream
        setSelectedTeams([]);
        const teams = sameByIdValue(allTeams, selectedValueStream?.teams);
        setSelectedTeams(teams);
        const fetchDisplayData = async () => {
            const result = await getValueStreamDisplayData(selectedValueStream?.id, selectedOrg?.id);
            setDisplayData(result);
        };
        fetchDisplayData();
    }, [selectedValueStream]);

    const mainIcon = () => {
        // TODO pass in type to change the icon on the detail tab
        // if (type && type.toLowerCase() === 'high') {
        //     return 'stream';
        // }
        // if (type && type.toLowerCase() === 'medium') {
        //     return 'compact';
        // }
        // if (type && type.toLowerCase() === 'low') {
        //     return 'module';
        // }
        return 'dashboard';
    };

    if (selectedValueStream) {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-7 col-12">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h2 className="card-heading">{displayData?.name}</h2>
                                </div>
                                <div>
                                    <SelectByIdModal
                                        modalTitle={<IntlMessages id="valueStream.teams" />}
                                        onUpdateHandler={onValueStreamTeamUpdate}
                                        onSelectRowHandler={onValueStreamSelect}
                                        onClickButtonHandler={onFetchSelectTeamData}
                                        selectLoader={showValueStreamLoader}
                                        data={teamSelectionList}
                                        width={width}
                                        actionButtonTextId={<IntlMessages id="valueStream.teams" />}
                                    />
                                    <DeleteItemCheck
                                        id={selectedValueStream?.id}
                                        onConfirm={onDeleteValueStream}
                                        alertMessage={<IntlMessages id="valueStream.deleteValueStream" />}
                                    />
                                    <Button size="sm" color="primary" onClick={() => dispatch(onEditValueStream(selectedValueStream))}>
                                        <i className="zmdi zmdi-edit zmdi-hc-fw" />
                                        <span>{<IntlMessages id="label.edit" />}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className="jr-card-body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="temp-section mb-4 mb-sm-0 text-center text-sm-left">
                                            <p>
                                                {/* <div className={`btn btn-sm text-uppercase btn-rounded ${style}`}>{order} Order</div> */}
                                                <i className={`detail-icon text-blue-grey zmdi zmdi-view-${mainIcon()} zmdi-hc-fw`} />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-9 text-center text-sm-left">
                                        <ValueStreamDetailTable displayData={displayData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ValueStreamEdit />
                    </div>

                    <div className="col-md-5">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <BasicDetailDrillDown entries={selectedTeams} title={<IntlMessages id="valueStream.teams" />} />
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="jr-card jr-card-full-height">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h3 className="card-heading">Please select an entry to display details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default ValueStreamDetail;


// WEBPACK FOOTER //
// ./components/Agile/valueStream/valueStreamDetail/index.js